import { render, staticRenderFns } from "./appointList.vue?vue&type=template&id=930006ca&scoped=true"
import script from "./appointList.vue?vue&type=script&lang=js"
export * from "./appointList.vue?vue&type=script&lang=js"
import style0 from "./appointList.vue?vue&type=style&index=0&id=930006ca&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "930006ca",
  null
  
)

export default component.exports